import { connect } from 'react-redux';
import SitePolicy from './SitePolicy.component';

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SitePolicy);
